import { Form, Offcanvas, Spinner } from "react-bootstrap";

const UpdateFormFieldLibrary = ({
  Show,
  Hide,
  setCategoryName,
  categoryName,
  buttonLoader,
  updateGlobalFormLibraryField,
}) => {
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Update {categoryName} Library Name</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group>
            <Form.Label className="fw-bold mb-1">
              Library{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCategoryName(e.target.value)}
              value={categoryName}
              className="br3"
              placeholder="Library Name"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
          <div className="p-2 bg-light border-top hstack justify-content-end gap-2">
            <button
              disabled={!categoryName || buttonLoader}
              onClick={updateGlobalFormLibraryField}
              className={`updateProfile`}
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm"/> Updating...
                </div>
              ) : (
                "Update library name"
              )}
            </button>
          </div>
      </Offcanvas>
    </>
  );
};

export default UpdateFormFieldLibrary;
